export default __webpack_public_path__ + "static/media/IMG-20240729-WA0003.0f6214b0.jpg";